import {takeLatestF, showBeError, putAll} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {none, opt} from 'ts-opt';
import {call, put, select} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';
import {getTableFiltersAndParams, simpleTableSelector, tablesAction} from 'utils/tables';

import {potentiallyChangeOfTableDataSource} from '../../utils/potentially-change-of-table-data-source';
import {animalBrowserAction, GetCalfBrowserTableDataAction} from '../action';
import {simpleAnimalBrowserSelector} from '../selector';

const tableId = 'calfBrowser';

function* execute(action: GetCalfBrowserTableDataAction): SagaIterator {
    const {tableDataRequest, farmId} = action.payload;

    if (tableDataRequest.isEmpty) return yield* put(animalBrowserAction.getCalfBrowserTableDataSuccess(none));
    yield* put(tablesAction.tableDataFetchStart(tableId));

    const tableState = yield* select(simpleTableSelector.tableState(tableId));
    const {filters, params, tableDataParams} = getTableFiltersAndParams({tableId, tableDataRequest, tableState});

    const response = yield* call(Api.getCalvesByFarm, filters, params, {farmId});

    const farmCode = (yield* select(simpleAnimalBrowserSelector.farmInfo)).prop('code').orUndef();
    if (!farmCode || potentiallyChangeOfTableDataSource(tableDataRequest.orCrash('No tableDataRequest'))) {
        const farmInfo = yield* call(Api.getAnimalsBrowserFarm, {farmId});
        if (farmInfo.isSuccess) yield* put(animalBrowserAction.setFarmName(farmInfo.data));
    }
    if (response.isSuccess) {
        yield* put(animalBrowserAction.getCalfBrowserTableDataSuccess(opt(response.data)));
        yield* put(tablesAction.tableDataFetchSuccess(tableId, tableDataParams));
    } else {
        yield putAll(showBeError(response, t('animalBrowser')('calvesInFarm')));
    }
}

/**
 * Loads calf-browser data for a selected farm.
 *
 * @returns The saga watcher for `GET_CALF_BROWSER_DATA`.
 */
export function* getCalfBrowserSaga(): SagaIterator {
    yield takeLatestF('animalBrowser/GET_CALF_BROWSER_DATA', execute);
}
